export const assert = (condition, message) => {
  if (!condition) {
    throw new Error(message);
  }
};

export const assertString = (value, fieldName) => {
  assert(
    typeof value === "string" && value.trim().length > 0,
    `${fieldName} must be a non-empty string`
  );
};

export const assertArray = (value, fieldName) => {
  assert(Array.isArray(value), `${fieldName} must be an array`);
};

export const assertBoolean = (value, fieldName) => {
  assert(typeof value === "boolean", `${fieldName} must be a boolean`);
};
